module.exports = __webpack_public_path__ + "img/02.e94cd4e1.png";